import { useState } from "react";
import { useEffect } from "react";
import { Button, Dropdown, Modal } from "react-bootstrap";
import useAxios from "../hooks/useAxios";
import imgUrl from "../util/imgUrl";
import { FaEye, FaExternalLinkAlt, FaPencilAlt, FaSave } from "react-icons/fa";
import { safeFormatCLP } from "../util/format";
import clsx from "clsx";
import OrderItemDescriptionModal from "./OrderItemDescriptionModal";
import OrderItemSubjectsModal from "./OrderItemSubjectsModal";
import UpdateOrderItemModal from "./UpdateOrderItemModal";


const OrderItemRow = ({ orderItem, index, selectedItems, getOrder, setSelectedItems, withOutCheck, orderTypeId, order }) => {

    const [showModal, setShowModal] = useState(false);

    const [currentItem, setCurrentItem] = useState(null);

    const [editSent, setEditSent] = useState(false);

    const [showModalImagePreview, setShowModalImagePreview] = useState(false);

    const [{ data: updateStatusData, loading: updateStatusLoading }, updateStatus] = useAxios({ url: `/order-items/${currentItem?.id}/update-status`, method: 'POST' }, { manual: true, useCache: false });

    const [{ loading: updateSentLoading }, updateSent] = useAxios({ url: `/order-items/${currentItem?.id}/sent`, method: 'PUT' }, { manual: true, useCache: false });

    useEffect(() => {
        if (updateStatusData) {
            setCurrentItem(updateStatusData?.data);
        }
    }, [updateStatusData])

    useEffect(() => {
        if (orderItem) {
            setCurrentItem(orderItem);
        }
    }, [orderItem])

    const handleStatusCode = (statusCode) => {
        if (updateStatusLoading) return;

        updateStatus({
            data: {
                status_code: statusCode
            }
        });
    }

    const handleSent = (e) => {
        updateSent({ data: { sent: e.target.value } });
        setCurrentItem(old => ({ ...old, sent: e.target.value }));
    }

    const handleSave = (newItem) => {
        setCurrentItem(newItem);
        setShowModal(false);

    }

    const handleUpdated = () => {
        setEditSent(false)
        getOrder?.();
    }

    return (
        <>
            <tr>
                <td className="text-center">
                    <div className="d-flex gap-2 align-items-cennter">
                        {
                            currentItem?.subjects?.length > 0 ?
                                <button
                                    onClick={() => setShowModal('item-subjects')}
                                    title="Modificaciones"
                                    className="bg-warning text-white rounded-circle"
                                    style={{ border: 'none', height: 20, width: 20 }}
                                >
                                    {currentItem?.subjects?.length}
                                </button>
                                :
                                null
                        }
                        {
                            order?.currentUserIsAdquisitionUser ?
                                <FaPencilAlt
                                    onClick={() => setShowModal('item-edit')}
                                    title="Editar"
                                    className="text-warning"
                                    style={{ fontSize: 17.5, cursor: 'pointer', marginTop: 2.5 }}

                                />
                                :
                                null
                        }
                        <FaEye
                            onClick={() => setShowModal('item-description')}
                            title="Mostrar descripción"
                            className="text-primary"
                            style={{ fontSize: 17.5, cursor: 'pointer', marginTop: 2.5 }}
                        />
                    </div>
                </td>
                <td>
                    <div className="d-flex align-items-center gap-1">
                        {
                            withOutCheck ?
                                null
                                :
                                <input
                                    type="checkbox"
                                    onChange={() => {
                                        if (selectedItems.includes(currentItem?.id)) {
                                            setSelectedItems(old => old.filter(id => id !== currentItem?.id));
                                        } else {
                                            setSelectedItems(old => [...old, currentItem?.id]);
                                        }
                                    }}
                                    checked={selectedItems.includes(currentItem?.id)}
                                />
                        }
                        {index + 1}
                    </div>
                </td>
                <td>
                    {currentItem?.productCode || '--'}
                </td>
                <td>
                    <img
                        onClick={() => {
                            setShowModalImagePreview(true);
                        }}
                        className="rounded"
                        style={{ width: 40, height: 40, cursor: 'pointer', objectFit: 'cover' }}
                        src={imgUrl(currentItem?.imagePath)}
                        alt=""
                    />
                    <br></br>

                    {currentItem?.name}
                    {currentItem?.feeForFormulating ? (
                        <div>
                            <span
                                className="badge bg-warning text-dark mt-1"
                                style={{ fontSize: '10px' }}
                                title={`Cobro por formular - Autorizado por: ${currentItem?.authorizedBy || '--'}, Cuenta: ${currentItem?.account || '--'}, Cebe: ${currentItem?.seven || '--'}`}
                            >
                                Por Formular
                            </span>
                        </div>
                    ) : null}
                </td>
                <td>{currentItem?.providerName}</td>
                <td>
                    {
                        currentItem?.filePath ?
                            <a href={imgUrl(currentItem?.filePath, '#')} target="_blank" className="btn btn-danger btn-xs">
                                Descargar
                            </a>
                            :
                            <a className="btn btn-light btn-xs">
                                No tiene
                            </a>
                    }
                </td>
                <td>
                    <div className="basic-dropdown">
                        <Dropdown>
                            {
                                updateStatusLoading ?
                                    <Dropdown.Toggle size="xs" variant='light'>
                                        Cargando...
                                    </Dropdown.Toggle>
                                    :
                                    <Dropdown.Toggle size="xs" className="text-capitalize" variant={currentItem?.status?.variant_color}>
                                        {currentItem?.status?.name}
                                    </Dropdown.Toggle>
                            }
                            <Dropdown.Menu>
                                {
                                    currentItem?.available_statuses?.map((status, i) => {
                                        return (
                                            <Dropdown.Item className="text-capitalize" onClick={() => handleStatusCode(status?.code)} href="#" key={i}>
                                                {status?.name}
                                            </Dropdown.Item>
                                        )
                                    })
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </td>
                <td>
                    {currentItem?.quantity}
                </td>
                <td>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control text-center"
                            style={{ height: 30 }}
                            value={currentItem?.sent}
                            disabled={!editSent || !currentItem?.can_update_sent}
                            onChange={handleSent}
                            placeholder="Introduzca la cantidad enviada..."
                        />
                        {
                            currentItem?.can_update_sent &&
                            <button onClick={() => editSent ? handleUpdated() : setEditSent(true)} className={clsx("btn btn-sm", {
                                "btn-outline-primary": editSent,
                                "btn-outline-warning": !editSent,
                            })} type="button" disabled={updateSentLoading} style={{ height: 30, padding: 5 }}>
                                {
                                    updateSentLoading ?
                                        <div className="spinner-border text-primary" role="status" style={{ height: 15, width: 15 }}>
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        :
                                        editSent ?
                                            <FaSave />
                                            :
                                            <FaPencilAlt />
                                }
                            </button>
                        }
                    </div>
                </td>
                <td>
                    {safeFormatCLP(Number(currentItem?.price))}
                </td>
                <td>{safeFormatCLP(Number(currentItem?.total))}</td>
            </tr >
            <Modal size="lg" className="fade" show={showModalImagePreview}>
                <Modal.Header>
                    <Modal.Title></Modal.Title>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setShowModalImagePreview(false)}
                    >
                    </Button>
                </Modal.Header>
                <Modal.Body>

                    <div className="text-center">
                        <img style={{ width: '40vw' }} src={imgUrl(currentItem?.imagePath)} />
                    </div>

                </Modal.Body>
            </Modal>
            <OrderItemDescriptionModal
                description={currentItem?.description}
                name={currentItem?.name}
                item={currentItem}
                show={showModal === 'item-description'}
                setShow={setShowModal}
            />

            <OrderItemSubjectsModal
                subjects={currentItem?.subjects}
                name={orderItem?.name}
                show={showModal === 'item-subjects'}
                setShow={setShowModal}
            />

            <UpdateOrderItemModal
                order={order}
                orderItem={currentItem}
                onSave={handleSave}
                setShow={setShowModal}
                show={showModal === 'item-edit'}
            />
        </>

    )
}

export default OrderItemRow;